import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useHashScroll(): void {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1); // Kebab-case or other format
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location.hash]);
}
